<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="exsbpricelist_createdAt"
        class="form-control-label">createdAt</label>
      <input
        id="exsbpricelist_createdAt"
        v-model="item.createdAt"
        :class="['form-control', isInvalid('createdAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('createdAt', $event.target.value)">
      <div
        v-if="isInvalid('createdAt')"
        class="invalid-feedback">{{ violations.createdAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpricelist_updatedAt"
        class="form-control-label">updatedAt</label>
      <input
        id="exsbpricelist_updatedAt"
        v-model="item.updatedAt"
        :class="['form-control', isInvalid('updatedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('updatedAt', $event.target.value)">
      <div
        v-if="isInvalid('updatedAt')"
        class="invalid-feedback">{{ violations.updatedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpricelist_deletedAt"
        class="form-control-label">deletedAt</label>
      <input
        id="exsbpricelist_deletedAt"
        v-model="item.deletedAt"
        :class="['form-control', isInvalid('deletedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('deletedAt', $event.target.value)">
      <div
        v-if="isInvalid('deletedAt')"
        class="invalid-feedback">{{ violations.deletedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpricelist_createdBy"
        class="form-control-label">createdBy</label>
      <input
        id="exsbpricelist_createdBy"
        v-model="item.createdBy"
        :class="['form-control', isInvalid('createdBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('createdBy', $event.target.value)">
      <div
        v-if="isInvalid('createdBy')"
        class="invalid-feedback">{{ violations.createdBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpricelist_updatedBy"
        class="form-control-label">updatedBy</label>
      <input
        id="exsbpricelist_updatedBy"
        v-model="item.updatedBy"
        :class="['form-control', isInvalid('updatedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('updatedBy', $event.target.value)">
      <div
        v-if="isInvalid('updatedBy')"
        class="invalid-feedback">{{ violations.updatedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpricelist_deletedBy"
        class="form-control-label">deletedBy</label>
      <input
        id="exsbpricelist_deletedBy"
        v-model="item.deletedBy"
        :class="['form-control', isInvalid('deletedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('deletedBy', $event.target.value)">
      <div
        v-if="isInvalid('deletedBy')"
        class="invalid-feedback">{{ violations.deletedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpricelist_state"
        class="form-control-label">state</label>
      <input
        id="exsbpricelist_state"
        v-model="item.state"
        :class="['form-control', isInvalid('state') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('state', $event.target.value)">
      <div
        v-if="isInvalid('state')"
        class="invalid-feedback">{{ violations.state }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpricelist_name"
        class="form-control-label">name</label>
      <input
        id="exsbpricelist_name"
        v-model="item.name"
        :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('name', $event.target.value)">
      <div
        v-if="isInvalid('name')"
        class="invalid-feedback">{{ violations.name }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpricelist_margin"
        class="form-control-label">margin</label>
      <input
        id="exsbpricelist_margin"
        v-model="item.margin"
        :class="['form-control', isInvalid('margin') ? 'is-invalid' : '']"
        type="number"
        step="0.1"
        required="true"
        placeholder=""
        @input="handleUpdateField('margin', $event.target.value)">
      <div
        v-if="isInvalid('margin')"
        class="invalid-feedback">{{ violations.margin }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbpricelist_coating"
        class="form-control-label">coating</label>
      <input
        id="exsbpricelist_coating"
        v-model="item.coating"
        :class="['form-control', isInvalid('coating') ? 'is-invalid' : '']"
        type="number"
        step="0.1"
        required="true"
        placeholder=""
        @input="handleUpdateField('coating', $event.target.value)">
      <div
        v-if="isInvalid('coating')"
        class="invalid-feedback">{{ violations.coating }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-primary">Submit</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
